import React from 'react';
import clsx from 'clsx';

export const NotFound = () => {
	return (
		<svg
			className={clsx('h-full', 'w-auto')}
			viewBox="0 0 684 687"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g style={{mixBlendMode: 'multiply'}}>
				<g clipPath="url(#clip0_219_1194)">
					<path
						d="M8.82202 444.477H83.9628L215.434 570.467L380.836 522.837L498.688 557.702L528.988 473.492L683.448 417.438"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M195.086 79.9197H266.787V325.035H195.086C172.609 325.035 154.358 306.784 154.358 284.306V120.645C154.358 98.1669 172.609 79.916 195.086 79.916V79.9197Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M224.834 228.822H332.029L455.37 339.431C468.959 351.619 476.726 369.009 476.726 387.264V542.953H398.664V393.4L302.899 307.406V406.611C302.899 422.091 296.355 436.855 284.884 447.251L167.348 553.762L114.928 495.915L224.837 396.317V228.822H224.834Z"
						fill="#04433B"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M438.075 111.472L427.969 151.495L368.858 102.043C361.467 95.8593 352.137 92.4674 342.498 92.46L216.196 92.3496C203.997 92.3386 192.419 97.7428 184.594 107.106L81.7553 229.601C62.5664 252.457 86.8027 285.744 114.449 274.501L205.902 237.304C205.902 237.304 211.31 228.824 224.896 228.824H329.464C344.901 228.824 357.416 216.309 357.416 200.872V155.461L424.533 211.611C438.988 223.703 461.112 216.555 465.755 198.29L484.241 125.599L438.072 111.476L438.075 111.472Z"
						fill="#B9F1E4"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M281.271 33.4746V79.9203H174.588C161.763 79.9203 151.367 69.5238 151.367 56.6993C151.367 43.8748 161.763 33.4746 174.588 33.4746H281.271Z"
						fill="white"
					/>
					<path
						d="M174.588 33.4746H281.268V79.9203H174.588"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M191.008 73.117C200.076 64.0486 200.076 49.3459 191.008 40.2775C181.94 31.2092 167.237 31.2092 158.168 40.2776C149.1 49.3459 149.1 64.0486 158.168 73.117C167.237 82.1853 181.94 82.1853 191.008 73.117Z"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M249.372 293.812H213.256V372.062H249.372V293.812Z"
						fill="#B9F1E4"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M213.256 315.5H249.372"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M197.467 188.545V161.38L222.446 89.7416C222.7 89.0169 223.384 88.5312 224.153 88.5312H240.16C241.411 88.5312 242.282 89.771 241.859 90.9446L208.58 184.023L197.467 188.541V188.545Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.217 207.576V171.802C361.217 169.025 360.749 166.266 359.833 163.643L334.059 89.7342C333.809 89.0132 333.128 88.5312 332.367 88.5312H316.331C315.091 88.5312 314.226 89.76 314.642 90.9262L356.633 208.37C357.523 210.864 361.213 210.224 361.213 207.576H361.217Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M270.761 167.605H250.17V284.152H270.761V167.605Z"
						fill="#04433B"
					/>
					<path
						d="M260.463 284.156V685.84"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M253.036 673.871H267.895"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M291.705 202.649V203.249C291.705 206.869 289.449 210.114 286.069 211.372C287.194 212.866 287.805 214.676 287.805 216.578V217.177C287.805 220.794 285.565 224.024 282.198 225.293C283.806 227.129 284.682 229.454 284.682 231.915V235.524C284.682 241.079 280.16 245.604 274.605 245.604H270.764L266.791 236.035L209.195 235.962L205.902 237.301L185.411 193.445L208.143 184.207L229.046 175.647L253.816 165.265C257.87 163.569 259.761 161.31 262.156 158.452L262.954 157.499C263.903 156.38 265.287 155.74 266.743 155.74C267.005 155.74 267.266 155.759 267.527 155.799C269.26 156.068 270.702 157.193 271.379 158.808L271.467 159.018C274.311 165.806 270.577 171.022 268.84 172.954L268.748 173.053L268.734 173.075C266.203 176.033 263.352 178.384 260.25 180.076L279.642 180.065C284.586 180.065 288.607 184.082 288.611 189.019C288.611 191.105 287.882 193.129 286.558 194.729C287.518 195.156 288.405 195.759 289.17 196.524C290.803 198.158 291.708 200.335 291.708 202.649H291.705Z"
						fill="white"
					/>
					<path
						d="M256.913 194.005L283.037 193.99C285.355 193.99 287.529 194.892 289.166 196.525C290.803 198.162 291.704 200.336 291.708 202.65V203.25C291.708 206.874 289.453 210.115 286.072 211.373"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M253.201 207.937L279.137 207.922C281.455 207.922 283.629 208.823 285.266 210.457C286.903 212.09 287.805 214.268 287.805 216.582V217.182C287.805 220.798 285.564 224.028 282.195 225.297"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M233.085 180.092L279.638 180.066C284.582 180.066 288.603 184.084 288.607 189.024C288.607 191.11 287.882 193.13 286.558 194.734"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M249.971 221.851L274.587 221.836C277.283 221.836 279.814 222.884 281.72 224.786C283.626 226.692 284.674 229.223 284.674 231.916V235.525C284.674 241.08 280.153 245.601 274.598 245.605H270.757L266.784 236.036L209.188 235.963L125.744 269.904"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M119.721 220.144L208.135 184.209L229.042 175.645L253.812 165.267C257.863 163.567 259.753 161.312 262.148 158.453L262.95 157.5C263.9 156.382 265.279 155.738 266.74 155.738C266.997 155.738 267.262 155.76 267.52 155.797C269.256 156.066 270.694 157.191 271.371 158.806L271.46 159.016C274.303 165.8 270.569 171.02 268.833 172.952L268.745 173.051L268.726 173.073C266.199 176.031 263.348 178.378 260.243 180.07"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M492.673 55.9401V76.0046C492.673 85.4298 491.669 94.8845 489.682 104.1L484.245 125.596C484.238 125.618 484.223 125.632 484.208 125.643C484.197 125.651 484.182 125.655 484.171 125.655C484.16 125.655 484.153 125.651 484.146 125.651L438.053 111.546C438.016 111.531 437.991 111.495 438.002 111.454L443.373 89.506C443.373 89.506 443.373 89.4803 443.384 89.4435L443.443 89.403C443.457 89.2411 443.516 88.7224 443.516 88.6967C443.494 88.704 443.413 89.2522 443.384 89.4435L441.901 90.4699C440.878 91.1762 439.687 91.5515 438.454 91.5515C438.086 91.5515 437.715 91.5183 437.347 91.4521C435.746 91.1615 434.356 90.2602 433.432 88.9211L433.009 88.3104C431.38 85.9449 431.659 82.8142 433.513 80.7724V80.765L429.709 83.3917C428.679 84.1054 427.484 84.4807 426.244 84.4807C425.872 84.4807 425.497 84.4439 425.122 84.3777C423.514 84.0797 422.116 83.1747 421.186 81.8282L420.814 81.2911C419.195 78.9477 419.442 75.8574 421.23 73.7973L416.543 77.0273C415.55 77.7153 414.387 78.0758 413.184 78.0758C412.205 78.0758 411.26 77.8367 410.421 77.3952C409.582 76.9574 408.847 76.3173 408.295 75.5153L407.699 74.6508C406.797 73.3448 406.459 71.7702 406.746 70.2141C407.033 68.6542 407.909 67.3041 409.211 66.4028L420.501 58.6146V55.1307C420.501 48.6559 423.68 42.5932 429.01 38.9143C431.854 36.9535 435.184 35.916 438.638 35.916H474.65C480.584 35.916 485.411 40.7427 485.411 46.6767V48.6302L486.073 48.6964C489.837 49.068 492.673 52.1839 492.673 55.9401Z"
						fill="white"
					/>
					<path
						d="M446.818 13.3898L426.827 18.3223L454.745 131.475L474.736 126.543L446.818 13.3898Z"
						fill="#04433B"
					/>
					<path
						d="M457.459 99.498L561.358 520.566"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M492.673 55.9401V76.0046C492.673 85.4298 491.669 94.8845 489.682 104.1C489.682 104.1 475.188 98.6186 463.047 98.1918C450.907 97.7651 443.373 89.506 443.373 89.506C443.373 89.506 443.373 89.4803 443.384 89.4435L443.443 89.403C443.457 89.2411 443.516 88.7224 443.516 88.6967C443.494 88.704 443.413 89.2522 443.384 89.4435L441.901 90.4699C440.878 91.1762 439.687 91.5515 438.454 91.5515C438.086 91.5515 437.715 91.5184 437.347 91.4521C435.746 91.1615 434.356 90.2602 433.432 88.9211L433.009 88.3104C431.38 85.9449 431.659 82.8142 433.513 80.7724V80.765L429.709 83.3917C428.679 84.1054 427.484 84.4807 426.244 84.4807C425.872 84.4807 425.497 84.4439 425.122 84.3777C423.514 84.0797 422.116 83.1747 421.186 81.8282L420.814 81.2911C419.195 78.9477 419.442 75.8574 421.23 73.7973L416.543 77.0273C415.55 77.7153 414.387 78.0758 413.184 78.0758C412.205 78.0758 411.26 77.8367 410.421 77.3952C409.582 76.9574 408.847 76.3173 408.295 75.5153L407.699 74.6508C406.797 73.3448 406.459 71.7702 406.746 70.2141C407.033 68.6542 407.909 67.3041 409.211 66.4028L420.501 58.6146V55.1307C420.501 48.6559 423.68 42.5932 429.01 38.9143C431.854 36.9535 435.184 35.916 438.638 35.916H474.65C480.584 35.916 485.411 40.7427 485.411 46.6767V48.6302L486.073 48.6964C489.837 49.068 492.673 52.1839 492.673 55.9401Z"
						fill="white"
					/>
					<path
						d="M420.498 58.6144V55.1268C420.498 48.652 423.68 42.5892 429.007 38.9104C431.851 36.9495 435.18 35.9121 438.635 35.9121H474.647C480.581 35.9121 485.411 40.7388 485.411 46.6765V48.6263L486.074 48.6925C489.833 49.0677 492.673 52.1837 492.673 55.9398V76.0044C492.673 85.4296 491.669 94.8806 489.682 104.096L484.241 125.595C484.238 125.614 484.223 125.632 484.205 125.643C484.194 125.647 484.183 125.651 484.168 125.651C484.161 125.651 484.153 125.651 484.146 125.651L438.053 111.546C438.017 111.535 437.994 111.494 438.002 111.454L443.373 89.5058C443.38 89.4764 443.402 89.458 443.428 89.4506H443.439C443.472 89.4506 443.491 89.4616 443.505 89.4764L445.713 92.0552C450.08 97.1541 456.433 100.083 463.143 100.083"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M468.724 60.7754L444.208 60.6466C441.648 60.6466 439.168 61.4228 437.042 62.8907L416.543 77.0323C415.55 77.7165 414.391 78.0771 413.188 78.0771C411.234 78.0771 409.406 77.1206 408.299 75.5166L407.699 74.6484C406.801 73.346 406.463 71.7678 406.746 70.2117C407.033 68.6555 407.909 67.3017 409.211 66.404L431.674 50.905C433.999 49.301 436.729 48.4512 439.573 48.4512L468.72 48.6094"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M468.724 84.7393L454.13 84.5995C451.687 84.5995 449.325 85.3352 447.306 86.7295L441.905 90.4709C440.882 91.1809 439.69 91.5562 438.458 91.5562C438.09 91.5562 437.718 91.5231 437.351 91.4569C435.75 91.1662 434.36 90.2649 433.436 88.9258L433.013 88.3151C431.38 85.9496 431.663 82.8189 433.514 80.7734"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M468.724 72.8195L448.994 72.6797C446.54 72.6797 444.179 73.4155 442.159 74.8098L429.713 83.3962C428.683 84.1062 427.484 84.4815 426.248 84.4815C425.876 84.4815 425.497 84.4484 425.126 84.3785C423.518 84.0842 422.116 83.1792 421.189 81.829L420.818 81.2919C419.199 78.9448 419.446 75.8545 421.233 73.7944"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M304.15 25.1892C304.15 25.1892 304.15 39.1064 310.172 43.1053C316.195 47.1042 332.257 51.3717 330.252 67.4336C328.243 83.4955 311.011 87.259 306.703 87.259H257.815C251.767 87.259 245.822 85.4343 240.94 81.8621C235.451 77.8448 230.492 71.1971 232.626 60.6535C236.893 39.5699 259.227 34.8021 259.227 34.8021L304.15 25.1855V25.1892Z"
						fill="#04433B"
					/>
					<path
						d="M290.994 64.2148H267.42V98.5276H290.994V64.2148Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M292.591 82.3984H264.871C261.403 82.3984 258.591 85.21 258.591 88.6783V93.3173C258.591 96.7856 261.403 99.5971 264.871 99.5971H292.591C296.059 99.5971 298.871 96.7856 298.871 93.3173V88.6783C298.871 85.21 296.059 82.3984 292.591 82.3984Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M285.152 99.5984V91.3945"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M267.56 99.5984V91.3945"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M290.432 99.5982V87.0312"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M438.005 111.455L420.737 180.139"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M357.413 121.498V155.458"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M197.467 135.514V188.544"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M185.404 193.438L205.899 237.301"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M398.664 542.953V661.379H561.645C561.645 638.762 543.309 620.423 520.688 620.423H504.251C489.05 620.423 476.725 608.098 476.725 592.897V542.953H398.664Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M572.291 661.375H386.34V686.137H434.68V677.062H472.219V686.137H572.291V661.375Z"
						fill="#04433B"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M398.664 626.105C412.949 626.105 424.548 637.705 424.548 651.99V661.378H398.664V626.109V626.105Z"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M499.391 619.992L483.781 629.657"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M514.062 620.418L495.587 651.615"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M114.928 495.914L27.1758 575.436L108.181 664.825H167.182V661.592C167.182 643.764 152.728 629.31 134.9 629.31C132.586 629.31 130.383 628.331 128.826 626.617L122.495 619.631C115.564 611.982 116.145 600.158 123.794 593.227L167.348 553.76L114.928 495.914Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M177.494 664.83H108.181L18.8982 566.307L0.551758 582.935L33.0104 618.756L39.7353 612.66L64.9429 640.476L58.2179 646.572L94.0758 686.138H177.494V664.83Z"
						fill="#04433B"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M53.2878 551.732C62.8797 562.318 62.0726 578.702 51.4869 588.294L44.5297 594.598L27.1492 575.417L53.2851 551.735L53.2878 551.732Z"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M125.585 623.045L103.008 632.592"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M134.897 629.311L109.553 649.29"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M550.891 509.151L565.316 505.59"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M278.733 76.4795C296.145 76.4795 310.261 62.364 310.261 44.9517C310.261 27.5393 296.145 13.4238 278.733 13.4238C261.32 13.4238 247.205 27.5393 247.205 44.9517C247.205 62.364 261.32 76.4795 278.733 76.4795Z"
						fill="white"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M306.159 28.5952C302.936 10.5982 287.253 -1.76279 270.864 0.915419C257.498 3.09699 247.757 14.6118 246.064 28.5952H306.159Z"
						fill="#B9F1E4"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M305.64 31.8326L249.846 42.2143C245.516 43.02 241.352 40.1615 240.546 35.8315C239.74 31.5015 242.599 27.337 246.929 26.5314L302.723 16.1496C307.053 15.3439 311.217 18.2024 312.023 22.5324C312.828 26.8625 309.97 31.0269 305.64 31.8326Z"
						fill="#B9F1E4"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M259.665 16.1914L258.466 24.3879"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M266.662 12.1367V22.8643"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M286.698 31.0466L284.016 19.6348"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M292.602 29.6594L289.986 18.5234"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 485.864V332.65"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 332.65L553.367 368.95"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 332.65L625.959 368.95"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 357.115L553.367 393.411"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 357.115L625.959 393.411"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 381.576L553.367 417.872"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 381.576L625.959 417.872"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 406.035L553.367 442.331"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M589.663 406.035L625.959 442.331"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 551.759V469.209"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 469.209L311.386 488.766"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 469.209L350.5 488.766"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 482.391L311.386 501.947"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 482.391L350.5 501.947"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 495.568L311.386 515.125"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 495.568L350.5 515.125"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 508.75L311.386 528.307"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M330.943 508.75L350.5 528.307"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.452 527.765V445.219"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.452 445.219L341.895 464.776"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.448 445.219L381.005 464.776"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.452 458.396L341.895 477.953"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.448 458.396L381.005 477.953"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.452 471.578L341.895 491.131"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.448 471.578L381.005 491.131"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.452 484.756L341.895 504.313"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M361.448 484.756L381.005 504.313"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 445.29V292.08"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 292.08L610.169 328.376"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 292.08L682.76 328.376"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 316.541L610.169 352.837"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 316.541L682.76 352.837"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 341.002L610.169 377.298"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 341.002L682.76 377.298"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 365.461L610.169 401.757"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M646.465 365.461L682.76 401.757"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 454.472V315.518"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 315.518L9.57617 348.44"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 315.518L75.4168 348.44"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 337.705L9.57617 370.624"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 337.705L75.4168 370.624"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 359.889L9.57617 392.807"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 359.889L75.4168 392.807"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 382.072L9.57617 414.991"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M42.4946 382.072L75.4168 414.991"
						stroke="#04433B"
						strokeWidth="3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_219_1194">
					<rect width="684" height="686.689" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
